// ContactInfoContext.jsx
import React, {createContext, useState, useEffect} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";

export const ContactInfoContext = createContext();

export const ContactInfoProvider = ({children}) => {
    const {i18n} = useTranslation();
    const [contactInfo, setContactInfo] = useState({
        "address": "",
        "email": "",
        "email2": "",
        "telPhone": "",
        "telPhone2": "",
        "wpPhone": "",
        "viberPhone": "",
        "tgUsername": "",
        "messenger": "",
        "instagramUrl": "",
        "facebookUrl": "",
        "googleMapsUrl": "",
        "telPhone_sales": "",
        "telPhone_rent": ""
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchContactInfo = async () => {
            try {
                setIsLoading(true);
                const res = await axios.get(`${process.env.REACT_APP_MY_API_KAY}/contact/information`, {
                    params: {language: i18n.language || "hy"},
                    cancelToken: source.token,
                });
                setContactInfo(res.data);
                setError(null);
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error("Error fetching contact information:", err);
                    setError(err.message);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchContactInfo();

        return () => {
            source.cancel("Request cancelled due to language change or unmount");
        };
    }, [i18n.language]);

    return (
        <ContactInfoContext.Provider value={{contactInfo, isLoading, error}}>
            {children}
        </ContactInfoContext.Provider>
    );
};